import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import React from "react";

type Props = {
	date: Date | null;
	setDate: (date: Date | null) => void;
	label: string | undefined;
	minDate?: Date;
	maxDate?: Date;
};

export const DateFilter = ({
	date,
	setDate,
	label = "Date",
	minDate,
	maxDate,
}: Props) => {
	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<DatePicker
				format="MM/DD/YYYY"
				minDate={minDate ? moment(minDate) : undefined}
				maxDate={maxDate ? moment(maxDate) : undefined}
				sx={{
					minWidth: "100%",
					borderTopLeftRadius: 3,
					borderTopRightRadius: 3,
				}}
				slotProps={{
					textField: {
						variant: "standard",
						size: "small",
						fullWidth: true,
					},
				}}
				label={label}
				value={date ? moment(date) : null}
				onChange={(newDate) => setDate(newDate ? newDate.toDate() : null)}
			/>
		</LocalizationProvider>
	);
};
